import Link from "next/link";
import React from "react";

const DSARProcedure = () => {
  return (
    <div className="p-4 bg-white sm:p-8">
      <div className="mx-auto max-w-4xl  p-6 text-[20px]  text-[#101828]  sm:p-8">
        <div className="mb-8 text-center">
          <p className="text-sm text-gray-500">Current as of 20 Jan 2024</p>
          <h1 className="mt-2 text-2xl font-semibold md:text-3xl">
            Procedure for Data Subject Access Requests (DSARs)
          </h1>
          <p className="mt-4 text-sm text-gray-500">
            At ThriveAgric, we are committed to ensuring transparency and
            protecting the privacy of our users. The following steps outline our
            procedure for handling Data Subject Access Requests (DSARs) across
            all our platforms.
          </p>
        </div>

        <div className="space-y-6">
          <div>
            <h2 className="text-lg font-semibold">
              1. Procedure for Data Subject Access Requests (DSARs)
            </h2>
            <p className="mt-2 text-gray-600">
              Data subjects can submit requests through this dedicated form
              available or via{" "}
              <Link
                href="mailto:info@thriveagric.com"
                className="text-[#48A928] underline"
              >
                info@thriveagric.com
              </Link>
              . Requests would include necessary identification details (e.g.,
              full name, contact information, and ID card) to verify the
              identity of the requestor.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold">
              2. Personal Data We Collect
            </h2>
            <p className="mt-2 text-gray-600">
              Within 7 days of receiving a request, we will acknowledge its
              receipt. We will also provide the data subject with an estimated
              timeline for processing the request, typically within 30 days.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold">3. Identity Verification</h2>
            <p className="mt-2 text-gray-600">
              To ensure the security of personal data, we will verify the
              identity of the requestor. This may require confirmation of
              personal information or submission of additional documentation.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold">4. Data Retrieval</h2>
            <p className="mt-2 text-gray-600">
              Upon verification, we will collect the relevant personal data from
              our systems. This may include data from third-party processors if
              applicable.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold">5. Data Delivery</h2>
            <p className="mt-2 text-gray-600">
              The requested personal data will be provided securely and in a
              structured, commonly used electronic format. The report will
              include:
            </p>
            <ol className="pl-6 mt-2 space-y-1 text-gray-600 list-decimal">
              <li>Categories of personal data processed.</li>
              <li>The purpose for processing the data.</li>
              <li>Recipients of the data, if any.</li>
              <li>The retention period.</li>
              <li>
                Information on the rights to rectification, erasure, and
                restriction of processing.
              </li>
            </ol>
          </div>

          <div>
            <h2 className="text-lg font-semibold">6. Record Keeping</h2>
            <p className="mt-2 text-gray-600">
              All DSARs will be documented in our records, including the date of
              submission, verification steps, and the date of response. This
              ensures proper auditing and compliance.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold">7. Special Cases</h2>
            <p className="mt-2 text-gray-600">
              If the request is complex or additional time is required, we will
              notify the data subject of an extension within the original 30-day
              period. If a request is denied, we will provide an explanation and
              inform the data subject of their right to lodge a complaint with
              the relevant Data Protection Authority.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DSARProcedure;
